import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';

class RoundButton extends Component {
  render() {
    const {
      // eslint-disable-next-line no-unused-vars
      dispatch, staticContext, primary, secondary, square, buttonRef, ...props
    } = this.props;
    return (
      <Button {...props} primary={primary} secondary={secondary} circular={!square} ref={buttonRef} />
    );
  }
}

export default withRouter(RoundButton);
